<template>
  <div v-if="$store.getters.marchand && $store.getters.marchand._env==='live'" class="row" style="padding: 5px">
                <loader v-show="loader" object="#29B3A6" color1="#29B3A6" color2="#17fd3d" size="4" speed="5" bg="#343a40" objectbg="#999793" opacity="80" name="spinning"></loader>
    <div class="container-fluid" v-if="$store.getters.marchand ">
      <div class="col-12 mb-0 pb=0">
        <v-btn @click="$router.go(-1)" outlined style="border: none;background: #fff" title="Retourner">
          <v-icon>mdi mdi-arrow-left</v-icon> Mes clients
         </v-btn>
      </div>
      <div class="col-12 pt-0 mt-0">
         <v-row v-if="clients">
      <v-col  cols="12" lg="4" md="4" class="mt-0 pt-0">
        <v-card style="padding: 15px;">
          <div class="row" style="background: #fff">
            <div class="col-md-12 pt-2 pb-0">
              <v-icon large>mdi-account-convert-outline</v-icon>
            </div>
            <div class="col-md-12 ">
              <div>Nom & Prénom du client :</div>
              <div style="font-weight: bold">
                {{ clients._last_name+' '+clients._first_name }} <a href="#" @click="customer=clients,dialogCustomer=true" class="badge badge-light float-right">plus <v-icon small>mdi-arrow-right-thin</v-icon> </a>
              </div>
            </div>
          </div>
        </v-card>
      </v-col>
      <v-col cols="12" lg="4" md="4" class="mt-0 pt-0">
        <v-card style="padding: 15px;">
          <div class="row"  style="background: #fff">
            <div class="col-md-12 pt-2 pb-0">
              <v-icon large>mdi-numeric-0-box-multiple-outline</v-icon>
            </div>
            <div class="col-md-12 ">
              <div>Nombre total de transaction :</div>
              <div style="font-weight: bold" class="text-uppercase">
                {{ clients.client_transactions ? clients.client_transactions.length : 0 }}
              </div>
            </div>
          </div>
        </v-card>
      </v-col>
      <v-col  cols="12" lg="4" md="4" class="mt-0 pt-0">
        <v-card style="padding: 15px;">
          <div class="row"  style="background: #fff">
            <div class="col-md-12 pt-2 pb-0">
              <v-icon large>mdi-numeric-1-box-multiple-outline</v-icon>
            </div>
            <div class="col-md-12 ">
              <div>Nombre total de transaction validé:</div>
              <div style="font-weight: bold">
                {{  this.number_transaction_valid  }}  </div>
            </div>
          </div>

        </v-card>
      </v-col>
      <v-col  cols="12" lg="4" md="4" class="mt-0 pt-0">
        <v-card style="padding: 15px">
          <div class="row"  style="background: #fff">
            <div class="col-md-12 pt-2 pb-0">
              <v-icon large>mdi-cash-multiple</v-icon>
            </div>
            <div class="col-md-12 ">
              <div>Montant total dû:</div>
              <div style="font-weight: bold">
                {{ sum_transaction }} XOF
                 </div>
            </div>
          </div>
        </v-card>
      </v-col>
      <v-col  cols="12" lg="4" md="4" class="mt-0 pt-0">
        <v-card style="padding: 15px">
          <div class="row"  style="background: #fff">
            <div class="col-md-12 pt-2 pb-0">
              <v-icon large>mdi-cash-fast</v-icon>
            </div>
            <div class="col-md-12 ">
              <div>Somme total des transactions payées:</div>
              <div style="font-weight: bold">
                {{ sum_valid }} XOF
                 </div>
            </div>
          </div>
        </v-card>
      </v-col>
      <v-col  cols="12" lg="4" md="4" class="mt-0 pt-0">
        <v-card style="padding: 15px;">
          <div class="row"  style="background: darkred;">
            <div class="col-md-12 pt-2 pb-0">
              <v-icon style="color: #fff!important" large>mdi-cash-minus</v-icon>
            </div>
            <div class="col-md-12 ">
              <div style="color: #fff!important">Nombre total de transaction impayé:</div>
              <div style="font-weight: bold;color: #fff!important">
                {{ number_transaction_rst }}
                 </div>
            </div>
          </div>
        </v-card>
      </v-col>
      
    </v-row>
      </div>
      <v-toolbar dense style="margin-bottom: 25px;padding: 0" height="90">
        <v-toolbar-title></v-toolbar-title>
        <div class="row">
          <div class="col-12 col-lg-4 col-md-4 p-0">
            <v-menu
                ref="menu"
                v-model="filter"
                :close-on-content-click="false"
                :return-value.sync="date"
                transition="scale-transition"
                offset-y
                min-width="290px">

              <template v-slot:activator="{ on, attrs }">
                <v-text-field style="margin-bottom: -3%"
                              v-model="date"
                              prepend-inner-icon="mdi-filter-variant"
                              v-bind="attrs" readonly solo
                              v-on="on">
                </v-text-field>
              </template>
              <v-date-picker v-model="date" no-title scrollable>
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
                <v-btn text color="primary" @click="$refs.menu.save(date)">OK</v-btn>
              </v-date-picker>
            </v-menu>
          </div>
          <div class="offset-lg-4 offset-md-4 col-12 col-lg-4 col-md-4 p-0">
            <v-text-field v-model="search" append-icon="mdi-magnify" solo label="Search" single-line
                          hide-details></v-text-field>
          </div>
        </div>
      </v-toolbar>
      <v-card elevation="7">
        <v-tabs v-model="transactions_tabs">
          <v-tab>Tous</v-tab>
        </v-tabs>
        <v-tabs-items v-model="transactions_tabs" style="padding: 15px">
          <v-tab-item>
           <v-data-table
                :headers="headers"
                :items="transactions"
                :items-per-page="15"
                class="elevation-1"
                :loading="loadingTransactions"
                no-data-text="Aucune transaction trouvée"
                :search="search"
            >
              <template v-slot:item._amount="{item}">
                {{ formatAmount(item._amount) }} F CFA
              </template>
              <template v-slot:item._created_at="{item}">
                {{ getDate(item._created_at) }}
              </template>
              <template v-slot:item._type_programmation="{item}">
              <span class="programm_text text-uppercase">  {{ item._programmation && item._programmation._type_programmation ? item._programmation._type_programmation : 'N/A' }}</span>
              </template>
              <template v-slot:item._status="{item}">
                <span :class="item._archive ? 'badge badge-danger text-uppercase' : (item._status ? 'badge badge-success text-uppercase' : 'badge badge-warning text-uppercase')">  
                  {{ item._archive ? 'archiver' :  (item._status ? 'Terminer' : 'en cours') }}
                </span>
              </template>
              <template v-slot:item.action="{item}">
                <div style="text-align:  right">
                  <v-btn
                    
                    @click="getClientTransactionsData(item)"
                    outlined
                    small>
                      <v-icon small>mdi-open-in-new </v-icon> Logs
                  </v-btn>
                </div>
              </template>
            </v-data-table>
           <div class="text-right" style="background : #f8f8f8">
                <v-pagination
                elevation="0"
                v-model="page"
                :length="total_pages"
                :total-visible="7"
                prev-icon="mdi-menu-left"
                next-icon="mdi-menu-right"
                @input="getMarchandClientTransaction"
                ></v-pagination>
              <!-- product pagination -->
        </div>
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </div>
      <logs-paiement v-if="openPaiementLogs" :openPaiementLogs="openPaiementLogs" :transaction_data="transaction_data" :logs_transactions="logs_transactions" @closeLogsTransaction="closeLogsTransaction"></logs-paiement>
  </div>
</template>

<script>
import {client} from "../../store/services/client";
import helpers from "../../mixins/helpers";

export default {
  name: "MarchanDetailsClient",
  mixins:[helpers(this)],
  data() {
    return {
      dialogCustomer:false,
      customer: {
        _unique_id: '',
        _first_name: '',
        _last_name: '',
        _email: '',
        _phone: null,
        _address: '',
        _category_id: null,
        _whatsapp: null,
        _prefix:'',
        _notifier_prefix:'',
        _notifier_first_name: '',
        _notifier_last_name: '',
        _notifier_email: '',
        _notifier_phone: null,
        _notifier_whatsapp: null,
      },
      loader:false,
      total_pages: 0,
      page: 1,
      openPaiementLogs:false,
      transaction_data:undefined,
      logs_transactions:undefined,
      clients: undefined,
      loadingTransactions:false,
      programmes_transaction: [],
      search: "",
      transactions_tabs: null,
      customer_transactions: [],
      transactions_headers: [
        {text: "Client", value: "_client"},
        {text: "Actions", value: "_actions"}
      ],
      headers_success: [
        {text: 'Type', value: '_type'},
        {text: 'Statut', value: '_status'},
        {text: 'Source', value: 'mean'},
        {text: 'Référence', value: '_reference'},
        {text: 'Montant', value: '_amount'},
        {text: 'Frais', value: '_fees'},
        {text: 'Numéro', value: '_num_source'},
        {text: 'Date', value: '_created_at'},
        {text: 'Action', value: 'action'},

      ],
      showPaiementDialog: false,
      transactions: undefined,
      filter:'',
      date: new Date().toISOString().substr(0, 10),
      sum_transaction : 0,
      number_transaction_valid : 0,
      number_transaction_rst : 0,
      sum_valid: 0,
    }
  },
  methods: {
    getMeanName(item){
      return item.mean._name+' '+item.mean._country._name+' ('+item.mean._type+')';
    },
    setDialog(){

    },
    checkisDashboard() {
      this.$emit('checkisDashboard', true);
    },
    closeLogsTransaction(){
      this.openPaiementLogs = false
      this.transaction_data=undefined;
      this.logs_transactions=undefined;
    },
    initialize(){
      this.getMarchandClientTransaction()
      this.getMarchandClientData()
    },
    async getMarchandClientTransaction(page=1){
      page=page-1;
      this.loadingTransactions=true
      const response = await client({
        method: 'post',
        url: `/marchand/client/transaction/paginate`,
        data: {page: page, client : this.$route.query.details }
      })
          .then(res => res.data)
          .catch(error => {
            console.log(error)
            return {
              error: true
            }
          })
      this.loadingTransactions=false
      if(response && !response.error)
        this.transactions = response.transactions
         this.page=response.page+1;
         this.total_pages = response.total_pages
    },
    async getNumberTransactionValid(arr){
      let sum = 0, valid =0, umpaid=0, sum_valid=0;
        for(const tr of arr){
          sum+=tr.transaction_data._amount;
          if(tr.transaction_data._status) {
            valid++;
            sum_valid+=tr.transaction_data._amount;
            }
          if(tr._number_notification>=4 && !tr.transaction_data._status){
            umpaid++
          }
        }
      this.sum_transaction = sum;
      this.number_transaction_valid = valid;
      this.number_transaction_rst = umpaid;
      this.sum_valid = sum_valid;
    },
    async getMarchandClientData(){
      const response = await client({
        method: 'get',
        url: `/marchand_customer/get/by/${ this.$route.query.details }`,
      })
          .then(res => res.data)
          .catch(error => {
            console.log(error)
            return {
              error: true
            }
          })

      if(response && !response.error)
        this.clients = response.marchandclient
        this.loader=false;
        if(this.clients && this.clients.client_transactions){
          this.getNumberTransactionValid(this.clients.client_transactions);
        }
      },
       async getClientTransactionsData(data){
         this.loader=true
         let transaction_id=data._id;
         this.transaction_data=data;
        const response = await client({
          method: 'post',
          url: `/transactions/get/by/${ this.$route.query.details }`,
          data: {transaction_id : transaction_id}
        })
            .then(res => res.data)
            .catch(error => {
              console.log(error)
              return {
                error: true
              }
            })

        if(response && !response.error){
          this.logs_transactions = response.transactions
          this.loader=false
          this.openPaiementLogs=true;
        }
        }
  },
  computed: {
    headers: function(){
      return [
        {text: '', value: 'action'},
        {text: 'Statut', value: '_status'},
        {text: 'Référence', value: '_reference'},
        {text: 'Nom', value: '_name'},
        {text: 'Montant', value: '_amount'},
        {text: 'Paiement par :', value: '_type_programmation'},
        {text: 'Date', value: '_created_at'},
      ]
    },
   transaction_logs_headers: function(){
      return [
        {text: 'Statut', value: '_status'},
        {text: 'Transaction_id', value: '_transaction_id'},
        {text: 'Nombre de notification', value: '_number_notification'},
        {text: 'Dernière notification', value: '_last_notification'},
        {text: 'Payé le', value: '_paid_at'},
        {text: 'Date', value: '_created_at'},
      ]
    }
  },
  created(){
    this.loader=true
    this.checkisDashboard();
    this.initialize()
  }
}
</script>

<style scoped>

</style>
